import { StateObject, Transition, TransitionService } from '@uirouter/core';

import { SessionService } from '../../app-lite/sessions/session.service';

export function MessagesResolver (
  $rootScope   : any,
  $transitions : TransitionService,
  sessionObjAPI: SessionService
) {
  $transitions.onStart({
    to: ( state : StateObject ) => {
      return state.name === 'app.company-messages'
        || state.name === 'app.reminders';
    }
  }, ( transition : Transition ) => {
    if ( !$rootScope.Company.hasWorkshop() || !sessionObjAPI.hasRights('companies' ) ) {
      return false;
    }
  });
}
